



































































import { SvgImage } from '@/app/components';
import { useSockets } from '@/app/composable/socket';
import store from '@/app/store';

import { computed, defineComponent } from '@vue/composition-api';
import { useNavigationItems } from '../composable';
import { UserRoles } from '../constants';
import UserNavigation from './UserNavigation.vue';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'NavigationMenu',
    components: {
        Icon,
        SvgImage,
        UserNavigation,
    },
    setup() {
        const isModelModerator = computed(() => store.getters.auth.hasRole(UserRoles.ModelModerator));
        const isAdmin = computed(() => store.getters.auth.hasRole(UserRoles.Admin));
        const user = computed(() => store.state.auth.user);
        const { connected, socketConnect } = useSockets();

        const { navigation } = useNavigationItems(user, isModelModerator, isAdmin);

        return { navigation, isModelModerator, connected, socketConnect };
    },
});
